export const ADVISING_REPORT_STATUSES = {
  PENDING: 'pending',
  OK: 'ok',
  ERROR: 'error',
}
